webpackJsonp([76],{

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0/KZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "01ue":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1g2b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "34KM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4yKV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export matchWildcard */
/* harmony export (immutable) */ __webpack_exports__["a"] = hasPrivilege;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_good_storage__ = __webpack_require__("bFR2");




// ─────────────────────────────────────────────
// 通配符匹配（与 Swift matchWildcard 逻辑完全一致）
// 支持 * 匹配任意字符序列、? 匹配单个字符
// 示例：'/auth/evaluation/*' 匹配 '/auth/evaluation/queryPlan'
// ─────────────────────────────────────────────
function matchWildcard(pattern, text) {
  if (!pattern || !text) return false;
  if (pattern === text) return true;

  var p = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(pattern);
  var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(text);
  var pLen = p.length;
  var tLen = t.length;

  var pIdx = 0;
  var tIdx = 0;
  var starIdx = -1;
  var matchIdx = -1;

  while (tIdx < tLen) {
    if (pIdx < pLen && (p[pIdx] === t[tIdx] || p[pIdx] === '?')) {
      pIdx++;
      tIdx++;
    } else if (pIdx < pLen && p[pIdx] === '*') {
      starIdx = pIdx;
      matchIdx = tIdx;
      pIdx++;
    } else if (starIdx !== -1) {
      pIdx = starIdx + 1;
      matchIdx++;
      tIdx = matchIdx;
    } else {
      return false;
    }
  }

  while (pIdx < pLen && p[pIdx] === '*') {
    pIdx++;
  }

  return pIdx === pLen;
}

// ─────────────────────────────────────────────
// Type 1：有权限点 + 有岗位 才可访问
// 旁路条件：positionId > 0 直接放行
// ─────────────────────────────────────────────
var TYPE1_URLS = ['/auth/archive/getarchivelist', '/auth/archive/getcataloglist', '/auth/rule/getrulelist', '/auth/duty/discuss/create'];

// ─────────────────────────────────────────────
// Type 2：自己在岗、上级 或 有权限 可访问
// 旁路条件：positionId > 0 || isSuperior
// ─────────────────────────────────────────────
var TYPE2_URLS = ['/auth/evaluation/queryUserEvaluationPosition*', '/auth/evaluation/editPlan', '/auth/evaluation/queryPlan', '/auth/evaluation/queryPlan/details', '/auth/evaluation/queryPlanSum/details'];

// ─────────────────────────────────────────────
// Type 3：上级 或 有权限 可访问
// 旁路条件：isSuperior
// ─────────────────────────────────────────────
var TYPE3_URLS = ['/auth/evaluation/addEvaluationTask', '/auth/evaluation/submitEvaluation'];

// 上级权限判断依据的 privilege_url（对应 Swift 的 XB6SViewModel.share.isAccessAuth）
var SUPERIOR_PRIVILEGE_URL = '/auth/evaluation/queryEvaluationPosition';

// ─────────────────────────────────────────────
// 内部工具：获取当前公司的 positionId
// 对应 Swift 的 SingletonCompanyModel.positionId
// ─────────────────────────────────────────────
function _getPositionId() {
  var detail = __WEBPACK_IMPORTED_MODULE_2_good_storage__["a" /* default */].session.get('companyDetail');
  return detail && detail.positionId > 0 ? detail.positionId : 0;
}

// ─────────────────────────────────────────────
// 内部工具：是否为上级/管理者
// 对应 Swift 的 isSuperior = XB6SViewModel.share.isAccessAuth
// 直接在 privilegeList 中查找上级标志 URL，避免递归
// ─────────────────────────────────────────────
function _isSuperior(privilegeList) {
  if (!privilegeList || privilegeList.length === 0) return false;
  return privilegeList.some(function (p) {
    return p.privilegeUrl && matchWildcard(p.privilegeUrl, SUPERIOR_PRIVILEGE_URL);
  });
}

// ─────────────────────────────────────────────
// 主函数：检查是否有指定 privilege_url 的访问权限
// 对应 Swift 的 isServiceAuthorized(serviceId:)
//
// 优先级（与 Swift 保持一致）：
//   1. Type 旁路检测（positionId / isSuperior 满足 → 直接放行）
//   2. privilegeList 显式权限匹配（通配符）
//   3. 都不满足 → 拒绝
//
// @param {string} url           接口的 privilege_url，如 '/auth/evaluation/addEvaluationTask'
// @param {object} companyDetail 可选，当前公司详情（含 privilegeList）
// @returns {boolean}            true = 有权限，false = 无权限
// ─────────────────────────────────────────────
function hasPrivilege(url, companyDetail) {
  var detail = companyDetail || __WEBPACK_IMPORTED_MODULE_2_good_storage__["a" /* default */].session.get('companyDetail');
  var privilegeList = detail && detail.privilegeList;

  var positionId = _getPositionId();
  var superior = _isSuperior(privilegeList);

  // ── Type 1 旁路：positionId > 0 直接放行 ──
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(TYPE1_URLS), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var pattern = _step.value;

      if (matchWildcard(pattern, url)) {
        if (positionId > 0) return true;
        break; // 命中 type1 但条件不满足，跳出继续走 privilegeList
      }
    }

    // ── Type 2 旁路：positionId > 0 或 上级 直接放行 ──
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(TYPE2_URLS), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _pattern = _step2.value;

      if (matchWildcard(_pattern, url)) {
        if (positionId > 0 || superior) return true;
        break;
      }
    }

    // ── Type 3 旁路：上级 直接放行 ──
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(TYPE3_URLS), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _pattern2 = _step3.value;

      if (matchWildcard(_pattern2, url)) {
        if (superior) return true;
        break;
      }
    }

    // ── 显式权限匹配（privilegeList 通配符遍历）──
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  if (!privilegeList || privilegeList.length === 0) return false;

  for (var i = 0; i < privilegeList.length; i++) {
    var privilege = privilegeList[i];
    if (privilege.privilegeUrl && matchWildcard(privilege.privilegeUrl, url)) {
      return true;
    }
  }

  return false;
}

/***/ }),

/***/ "A5NA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFileIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSecretgradeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLogo; });
// 获取文档图标
function getFileIcon(fileType, fn, url) {
  // console.log('url', url, fileType, fn)
  switch (fileType) {
    case 'Image':
      if (url != null) {
        return url;
      } else {
        return __webpack_require__("EiOp");
      }
    case 'Audio':
      return __webpack_require__("xgJh");
    case 'Video':
      return __webpack_require__("XaOL");
    default:
      if (fn) {
        var fns = fn.split('.'); // 获取截取的最后一个元素 ，判断后缀名字
        if (fns.slice(-1) == 'doc' || fns.slice(-1) == 'docx') {
          return __webpack_require__("0/KZ");
        } else if (fns.slice(-1) == 'xls' || fns.slice(-1) == 'xlsx') {
          return __webpack_require__("nKN5");
        } else if (fns.slice(-1) == 'ppt' || fns.slice(-1) == 'pptx') {
          return __webpack_require__("GajI");
        } else if (fns.slice(-1) == 'pdf') {
          return __webpack_require__("IkXC");
        } else if (fns.slice(-1) == 'rar' || fns.slice(-1) == 'zip') {
          return __webpack_require__("zBRd");
        } else if (fns.slice(-1) == 'txt') {
          return __webpack_require__("O18x");
        } else if (fns.slice(-1) == 'jpg' || fns.slice(-1) == 'png' || fns.slice(-1) == 'jpeg') {
          if (url == '' || url == undefined || url == null) {
            // console.log('icon_tupian')
            return __webpack_require__("EiOp");
          } else {
            return url;
          }
        } else {}
      }
  }
  return __webpack_require__("i3O8");
}

// 获取档案级别图标
function getSecretgradeIcon(secretgrade) {
  if (secretgrade == 1) {
    return __webpack_require__("ZiYx");
  } else if (secretgrade == 2) {
    return __webpack_require__("vmcJ");
  } else if (secretgrade == 3) {
    return __webpack_require__("JWnO");
  }
}

// 设置默认头像
function getLogo(logoUrl) {
  if (logoUrl) {
    return logoUrl;
  } else {
    return __webpack_require__("HfaK");
  }
}


/***/ }),

/***/ "Alzq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BtlD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EiOp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "GajI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAIAAAD/gAIDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkE4NTBEREUwRjVFMjExRTdCMjAyODgwQjVGMTY4OTA5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkE4NTBEREUxRjVFMjExRTdCMjAyODgwQjVGMTY4OTA5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTg1MEREREVGNUUyMTFFN0IyMDI4ODBCNUYxNjg5MDkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTg1MEREREZGNUUyMTFFN0IyMDI4ODBCNUYxNjg5MDkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6c/ZeLAAACLElEQVR42uzcv0sCYRzH8c5fVyYcQQUhFGEGSYFD0dIQVFtDNDZHf0IQzRH0VzTV1BC0Fi0N0RIo1RJU4FBIciFGp6ddv82s7C577on3FweH5z6cL5/nue/joKLregNVW3kgAAsssMACCywIwAILLLDAAgsCsMACCyywwIIALLDAAgsssCAACyywwAILLAjAAgsssMACC4Lay2f7ysaTdU/m6NthxZaYqUXzHYO/mBC42PWltu3d9l1s1tS6/hrL+py+y43vxz2OUUPx26Hliru0naDkszVdWK2M6Izbl6Enexjcm/Xq5wITRC7D8rqZqrKaPLm0L51Uk0uKkXqYDkaq6WAhO77mPOEuMmm9Po5XT7fUxPzT+9zIRqG1T5oNvhhsNTpHsxObxVD8dXb8aGo4T5DsaVjyB43eubeZnE78fYJMrYOpdQtPkAar5G8WniANllc/E54gDZb/bLNsQUWEJLiodfj0q8il1ePV1wayFAj/9HHuPMF1WFaDU7lwrvaVfMZ7vfPuqNG/WL8EebBeWsGvDmUDK1bTVL8E6ZfhQ2MZihfaR42eaavDFJXgLizrbFG1maz9fO88QRos55uuwG3bdb86/I8CCyywwAILLMp+n1UIj5ntw456K8cJFWVqEetI9Nz3B9t+HUvhX45YhmCBBRZYYEEAFlhggQUWWBCABRZYYIEFFgRggQUWWGCBBQFYYIEFFlhgQQAWWGCBBRZYEIBVl7oXYACD1810ze/xdgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "HNGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCommonData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LongFormatData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clientSecret; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fromDateFormat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_user__ = __webpack_require__("vMJZ");



var clientId = 'web_garsia';
var clientSecret = 'web_garsia';
if (location.host.indexOf('pm.xb969.com') >= 0) {
  clientId = '351217a1-60cd-4693-a2f9-4d29e6b85515';
  clientSecret = 'e1ba041e-b4df-4dd4-86c7-118865c59641';
} else if (location.host.indexOf('garcia.xb969.com') >= 0) {
  clientId = '351217a1-60cd-4693-a2f9-4d29e6b85515';
  clientSecret = 'e1ba041e-b4df-4dd4-86c7-118865c59641';
}

function getCommonData() {
  var version = Object(__WEBPACK_IMPORTED_MODULE_1_api_user__["b" /* getStorage */])('version');
  var commonData = {
    privatefield: 'Web',
    reqtime: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
    // version: version === '' ? 'V20180412' : version.version,
    version: 'V3.0.6',
    clientType: 'Web',
    reqdata: {}
  };
  return commonData;
}

function LongFormatData(long) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(long).format('YYYY-MM-DD HH:mm:ss');
}

function fromDateFormat(value) {
  var nowDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
  var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD');
  var nowY = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY');
  var createY = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY');
  if (nowDate == date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('HH:mm');
  } else if (nowY == createY) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('MM-DD');
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD');
  }
}
// timeType 1 为天数 2为小时
function DateDiff(startDt, endDt) {
  var timeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var sDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDt);
  var eDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDt);
  var longTime = eDate.diff(sDate);
  var hour = longTime / (60 * 60 * 1000);
  // 向上取整,有小数就整数部分加1
  hour = Math.ceil(hour);
  var modDay = hour % 24;
  modDay = modDay > 8 ? 8 : modDay;
  var day = hour / 24;
  // 丢弃小数部分,保留整数部分
  day = parseInt(day);
  if (timeType == 1) {
    var workDay = day + modDay / 8;
    // 四舍五入
    workDay = Math.round(workDay * 100) / 100;
    return workDay;
  } else if (timeType == 2) {
    var workHour = 0;
    if (modDay > 8) {
      workHour = day * 8 + 8;
    } else {
      workHour = day * 8 + modDay;
    }
    return workHour;
  }
  return null;
  //  向下取整
  // Math.floor(7 / 2)
}



/***/ }),

/***/ "HfaK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/avatar.b85e863.png";

/***/ }),

/***/ "IMJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iview__ = __webpack_require__("BTaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_iview__);

function notice(title) {
  var desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'info';
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;

  if (type == 'info') {
    __WEBPACK_IMPORTED_MODULE_0_iview___default.a.Notice.info({
      title: title,
      desc: desc,
      duration: duration
    });
  } else if (type == 'success') {
    __WEBPACK_IMPORTED_MODULE_0_iview___default.a.Notice.success({
      title: title,
      desc: desc,
      duration: duration
    });
  } else if (type == 'warning') {
    __WEBPACK_IMPORTED_MODULE_0_iview___default.a.Notice.warning({
      title: title,
      desc: desc,
      duration: duration
    });
  } else if (type == 'error') {
    __WEBPACK_IMPORTED_MODULE_0_iview___default.a.Notice.error({
      title: title,
      desc: desc,
      duration: duration
    });
  }
}

function message(des) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';

  if (type == 'warning') {
    notice(des, '', 'warning');
    // iView.Message.warning(des)
  } else if (type == 'success') {
    notice(des, '', 'success');
    // iView.Message.success(des)
  } else if (type == 'error') {
    notice(des, '', 'error');
    // iView.Message.error(des)
  }
}



/***/ }),

/***/ "IMuC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCompanylist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCompanyDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");



function getCompanylist() {
  var url = 'security/company/getcompanylist';
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(url, {}).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

function getCompanyDetail(companyid) {
  var url = 'security/company/getcompanydetail';
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(url, {
    reqdata: {
      companyid: companyid
    }
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/user.js
var user = __webpack_require__("vMJZ");

// EXTERNAL MODULE: ./node_modules/good-storage/dist/storage.esm.js
var storage_esm = __webpack_require__("bFR2");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/modules/company.js


var _mutations;

// 给mutations的方法定义别名
var mutationTypes = {
  /// 管理授权 Type 1 = 管理授权人 2 = 档案授权人 3 = 建议授权人
  MANAGER_AUTHTYPE: 'MANAGER_AUTHTYPE', //
  /// 岗位的请求 year 和 month 信息， 保存
  TASK_REQYEARMONTH: 'TASK_REQYEARMONTH', //
  /// 岗位考核表 - 是否是点击 查看 任务详情
  TASK_SCORE_TASKDETAIL: 'TASK_SCORE_TASKDETAIL',
  /// 岗位考核表 - 是否是点击 查看 任务详情
  TASK_KEEP_ARRAY: 'TASK_KEEP_ARRAY'
};

function getInitialState() {
  return {
    // 管理授权 默认为 1
    managerAuthType: 1,
    taskReqYearMonth: {},
    taskScoreLookDetail: {
      lookDetail: false, // 查看详情
      taskDetail: {}
    },
    keepArray: []
  };
}

// mttation 处理结果
var mutations = (_mutations = {}, defineProperty_default()(_mutations, mutationTypes.MANAGER_AUTHTYPE, function (state, res) {
  // 把返回结果,赋予state里面的参数
  state.managerAuthType = res;
}), defineProperty_default()(_mutations, mutationTypes.TASK_REQYEARMONTH, function (state, res) {
  // 把返回结果,赋予state里面的参数
  state.taskReqYearMonth = res;
}), defineProperty_default()(_mutations, mutationTypes.TASK_SCORE_TASKDETAIL, function (state, res) {
  // 把返回结果,赋予state里面的参数
  state.taskScoreLookDetail = res;
}), defineProperty_default()(_mutations, mutationTypes.TASK_KEEP_ARRAY, function (state, name) {
  // 把返回结果,赋予state里面的参数
  state.keepArray.push(name);
}), _mutations);

// action 发起请求
var actions = {
  setManagerAuthType: function setManagerAuthType(_ref, res) {
    var commit = _ref.commit,
        state = _ref.state;

    console.log('ivu-icon-android-restaurant');

    commit(mutationTypes.MANAGER_AUTHTYPE, res);
  },
  setTaskReqYearMonth: function setTaskReqYearMonth(_ref2, res) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(mutationTypes.TASK_REQYEARMONTH, res);
  },
  setTaskScoreTaskDetail: function setTaskScoreTaskDetail(_ref3, res) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit(mutationTypes.TASK_SCORE_TASKDETAIL, res);
  },
  commitTaskKeepArray: function commitTaskKeepArray(_ref4, name) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit(mutationTypes.TASK_KEEP_ARRAY, name);
  }
};

// module里面的参数
var getters = {
  getManagerAuthType: function getManagerAuthType(state) {
    return state.managerAuthType;
  },
  getTaskReqYearMonth: function getTaskReqYearMonth(state) {
    return state.taskReqYearMonth;
  },
  getTaskScoreTaskDetail: function getTaskScoreTaskDetail(state) {
    return state.taskScoreLookDetail;
  }

  // module 要暴露出去的东西
};var company_module = {
  namespaced: true,
  getters: getters,
  state: getInitialState(),
  mutations: mutations,
  actions: actions

  // 把内容暴露出去
};/* harmony default export */ var company = (company_module);
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["default"].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: {
    user: Object(user["b" /* getStorage */])('user'),
    currentCompany: Object(user["b" /* getStorage */])('currentCompany'),
    messageCount: storage_esm["a" /* default */].session.get('message_count'),
    pendingCount: storage_esm["a" /* default */].session.get('pending_count'),
    checkTaskDetail: [],
    keepArray: [],
    sixSPassWord: '',
    YearScoreRank: null,
    MonthScoreRank: null
  },
  mutations: {
    setUser: function setUser(state, userData) {
      state.user = userData;
    },
    removeUser: function removeUser(state) {
      state.user = null;
    },
    setCompany: function setCompany(state, item) {
      state.currentCompany = item;
      Object(user["e" /* setStorage */])('currentCompany', item);
    },
    setMessageCount: function setMessageCount(state, count) {
      state.messageCount = count;
      storage_esm["a" /* default */].session.set('message_count', count);
    },
    setPendingCount: function setPendingCount(state, count) {
      state.pendingCount = count;
      storage_esm["a" /* default */].session.set('pending_count', count);
    },
    loginOutSet: function loginOutSet(state) {
      state.messageCount = 0;
      state.user = '';
      state.currentCompany = '';
    },
    clearKeep: function clearKeep(state) {
      state.keepArray = [];
    },
    setKeep: function setKeep(state, name) {
      state.keepArray.push(name);
    },
    setCheckTaskDetail: function setCheckTaskDetail(state, checkTaskDetail) {
      state.checkTaskDetail = checkTaskDetail;
    },
    removeKeep: function removeKeep(state, name) {
      var index = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(state.keepArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item == name) {
            state.keepArray.splice(index, 1);
            break;
          }
          index++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    setSixSPassWord: function setSixSPassWord(state, item) {
      state.sixSPassWord = item;
    },
    setYearScoreRank: function setYearScoreRank(state, item) {
      state.YearScoreRank = item;
    },
    setMonthScoreRank: function setMonthScoreRank(state, item) {
      state.MonthScoreRank = item;
    }
  },
  // getters
  getters: {
    checkTaskDetail: function checkTaskDetail(state) {
      return state.checkTaskDetail;
    }
  },

  actions: {
    checkTaskDetail: function checkTaskDetail(context, seek) {
      console.log(seek);
      context.commit('checkTaskDetail');
    }
  },
  modules: {
    company: company
  }
});

/* harmony default export */ var src_store = __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IkXC":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "JU1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/base/footer/footer.vue + 2 modules
var footer = __webpack_require__("lGbR");

// EXTERNAL MODULE: ./src/base/header/header.vue + 2 modules
var header = __webpack_require__("hUrq");

// EXTERNAL MODULE: ./src/api/config.js
var config = __webpack_require__("T452");

// EXTERNAL MODULE: ./src/common/js/tip.js
var tip = __webpack_require__("IMJW");

// EXTERNAL MODULE: ./src/api/main.js
var main = __webpack_require__("IMuC");

// EXTERNAL MODULE: ./src/api/unifyIcon.js
var unifyIcon = __webpack_require__("A5NA");

// EXTERNAL MODULE: ./node_modules/good-storage/dist/storage.esm.js
var storage_esm = __webpack_require__("bFR2");

// EXTERNAL MODULE: ./src/common/js/permission.js
var permission = __webpack_require__("4yKV");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var TOP_HEIGHT = 50;
var INIT_TOP = 130;
var MENU_TOP = 80;
/* harmony default export */ var views_main = ({
  components: {
    footerb: footer["a" /* default */],
    headert: header["a" /* default */]
  },
  data: function data() {
    return {
      isTop: false,
      menushik: false,
      showTop: INIT_TOP,
      storeShow: false,
      componylist: [],
      showMenu: [],
      routerShow: false,
      top: '',
      left: '',
      positionName: null,
      mgrdeptlist: []
    };
  },
  created: function created() {
    this.operateMenus = operateMenus;
    this._getCompanylist(1);
    // 当消息条数不存在时跳转到首页
    var messageCount = storage_esm["a" /* default */].session.get('message_count');
    if (messageCount == undefined) {
      this.changeMenus(true, true);
    } else {
      this.changeMenus();
    }
    // this.companyDetail = storage.session.get('companyDetail')
  },
  mounted: function mounted() {
    this.scrollBar();
    this.setMinHeight();
  },

  computed: {
    // 是否配置导航栏 设置 按钮 返回true 则 有设置按钮
    configSettingMenus: function configSettingMenus() {
      // const privilegeList = this.$store.state.currentCompany.privilegeList
      // return privilegeList && privilegeList.length > 0
      // 暂时不通过权限判断，直接放开“设置”入口
      return true;
    }
  },
  methods: {
    goToRouter: function goToRouter(name, positionId) {
      if (name == 'institution') {
        if (this.$store.state.currentCompany.userright == 5 || this.$store.state.currentCompany.userright == 6) {
          Object(tip["b" /* notice */])('您没有发起制度权限', '');
          return;
        }
      } else if (name == 'archive') {
        if (this.$store.state.currentCompany.userright == 5) {
          Object(tip["b" /* notice */])('您没有档案查看权限', '');
          return;
        }
      } else if (name == 'leave') {
        if (this.companyDetail.workflowinfo.hasleaveright != 1) {
          Object(tip["b" /* notice */])('你没有发起请假权限', '');
          return;
        }
      }
      if (positionId) {
        this.$router.replace({ name: name, params: { id: positionId } });
      } else {
        if (name == 'task') {
          storage_esm["a" /* default */].session.remove('deptAuth');
        }
        this.$store.commit('removeKeep', name);
        storage_esm["a" /* default */].session.set('scrollbar', 50);
        this.$router.replace({ name: name });
      }
    },
    changeStore: function changeStore($e) {
      if (this.componylist.length === 1) {
        return;
      }
      this.storeShow = !this.storeShow;
      if (this.storeShow) {
        this.top = $e.clientY - 10 + 'px';
        this.left = $e.clientX - 50 + 'px';
        this._getCompanylist(2);
      }
    },
    filterMenus: function filterMenus(isplugin) {
      var _this = this;

      return this.showMenu.filter(function (item) {
        if (isplugin) {
          if (item.name == 'institution') {
            if (!(_this.$store.state.currentCompany.userright == 5 || _this.$store.state.currentCompany.userright == 6)) {
              return item.meta.isplugin == isplugin;
            }
          } else if (item.name == 'reimbur') {
            if (_this.$store.state.currentCompany.userright != 6) {
              return item.meta.isplugin == isplugin;
            }
          } else if (item.name == 'archive') {
            if (_this.$store.state.currentCompany.userright != 5) {
              return item.meta.isplugin == isplugin;
            }
          } else if (item.name == 'leave') {
            if (_this.companyDetail.workflowinfo.hasleaveright == 1) {
              return item.meta.isplugin == isplugin;
            }
          } else {
            return item.meta.isplugin == isplugin;
          }
        } else {
          if (item.name == 'sixS') {
            if (Object(permission["a" /* hasPrivilege */])('/auth/evaluation/queryEvaluationPosition')) {
              return item.meta.isplugin == false;
            } else {
              return item.meta.isplugin == true;
            }
          }
          return item.meta.isplugin == isplugin;
        }
      });
    },
    _getLogo: function _getLogo(url) {
      return Object(unifyIcon["b" /* getLogo */])(url);
    },
    changeMenus: function changeMenus() {
      var _this2 = this;

      var isGo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // debugger
      setTimeout(function () {
        if (_this2.$route.fullPath.indexOf('operate') >= 0 || message) {
          _this2.showMenu = _this2.operateMenus;
          if (isGo) {
            _this2.$router.push({ name: 'message' });
          }
        } else {
          _this2.showMenu = _this2.updateSetupMenus();
          if (isGo) {
            if (_this2.showMenu.length) {
              if (_this2.showMenu[0].meta.isplugin) {
                // if (!this.mgrdeptlist.length) {
                //   return
                // }
                console.log(' this.showMenu', _this2.showMenu);
                console.log(' this.positionId', _this2.mgrdeptlist[0].positionId);
                _this2.$router.push({ name: _this2.showMenu[0].name, params: { id: _this2.mgrdeptlist[0].positionId } });
              } else {
                console.log(' this.showMenu123', _this2.showMenu);
                _this2.$router.push({ name: _this2.showMenu[0].name });
              }
            }
          }
        }
      }, 20);
    },
    setMinHeight: function setMinHeight() {
      var body = document.documentElement || document.body;
      var screenHiehgt = body.clientHeight;
      this.$refs.maincontent.style.minHeight = screenHiehgt - 50 + 'px';
    },
    goTop: function goTop() {
      window.scrollTo(0, 50);
    },
    scrollBar: function scrollBar() {
      var _this3 = this;

      window.addEventListener('scroll', function () {
        var body = document.documentElement || document.body;
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        var clientHeight = body.clientHeight;
        var scrollHeight = body.scrollHeight;
        // 判断是否到底部
        if (scrollTop + clientHeight + 80 >= scrollHeight) {
          if (!_this3.menushik) _this3.menushik = true;
        } else {
          if (_this3.menushik) _this3.menushik = false;
        }
        // 判断是否是顶部
        if (scrollTop >= TOP_HEIGHT) {
          if (!_this3.isTop) {
            _this3.isTop = true;
            _this3.showTop = MENU_TOP;
          }
        } else {
          _this3.showTop = INIT_TOP - scrollTop;
          if (_this3.isTop) _this3.isTop = false;
        }
      });
    },
    selectStore: function selectStore(item) {
      storage_esm["a" /* default */].session.clear();
      this.setComPony(item);
      this.changeMenus();
      this.$store.commit('clearKeep');
      Object(tip["b" /* notice */])('机构切换成功', '');
      this.goTop();
      this.$router.replace({ name: 'message' });
      this.changeStore();
    },
    setComPony: function setComPony(item) {
      this.routerShow = false;
      this.$store.commit('setCompany', item);
      this._getCompanyDetail(item.companyid);
    },
    updateSetupMenus: function updateSetupMenus() {
      var userright = this.$store.state.currentCompany.userright;
      var menus = getSetupMenus(userright);
      console.log('menus', menus);
      return menus;
    },
    _getCompanylist: function _getCompanylist() {
      var _this4 = this;

      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      Object(main["b" /* getCompanylist */])().then(function (res) {
        if (res.code === config["c" /* resCode */].ERR_OK) {
          _this4.componylist = res.resdata;
          if (first == 1 && !_this4.$store.state.currentCompany) {
            _this4.setComPony(_this4.componylist[0]);
          } else if (first == 0 || first == 1) {
            _this4._getCompanyDetail(_this4.$store.state.currentCompany.companyid);
          }
        }
      });
    },
    _getCompanyDetail: function _getCompanyDetail(companyid) {
      var _this5 = this;

      Object(main["a" /* getCompanyDetail */])(companyid).then(function (res) {
        if (res.code === config["c" /* resCode */].ERR_OK) {
          var companyDetail = res.resdata;
          if (_this5.$store.state.currentCompany.userright == 3) {
            // this.mgrdeptlist = [{
            //   positionId: companyDetail.positionId,
            //   positionName: companyDetail.positionName,
            //   workflowlist: companyDetail.workflowlist
            // }]
            _this5.mgrdeptlist = [];
          } else {
            _this5.mgrdeptlist = [];
          }

          _this5.companyDetail = companyDetail;
          storage_esm["a" /* default */].session.set('companyDetail', companyDetail);
          _this5.routerShow = true;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f6bc9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('headert'),_vm._v(" "),_c('div',{staticClass:"mainbody"},[_c('div',{staticClass:"main-header",class:{ 'shiktop': _vm.isTop }},[_c('div',{staticClass:"middle"},[_c('div',{staticClass:"middle-body"},[_c('img',{staticClass:"header-img store-logo",attrs:{"src":_vm._getLogo(_vm.$store.state.currentCompany.logo)}}),_vm._v(" "),_c('div',{staticClass:"middle-content"},[_c('span',{staticClass:"store-name extend-click",on:{"click":_vm.changeStore}},[_vm._v("\n              "+_vm._s(_vm.$store.state.currentCompany.shortname)+"\n              "),(this.componylist.length > 1)?_c('i',{staticClass:"iconfont icon-arrow-down"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"middle-post"},[_vm._v(_vm._s(_vm.$store.state.currentCompany.positionName))])]),_vm._v(" "),_c('router-link',{staticClass:"link",attrs:{"tag":"span","to":{ name: 'operate' },"replace":""},nativeOn:{"click":function($event){return _vm.changeMenus(true)}}},[_vm._v("\n            操作\n          ")]),_vm._v(" "),(_vm.configSettingMenus)?_c('router-link',{staticClass:"link",attrs:{"tag":"span","to":{ name: 'setup' },"replace":""},nativeOn:{"click":function($event){return _vm.changeMenus(true)}}},[_vm._v("\n            设置\n          ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"menus-wrap"},[_c('div',{staticClass:"menus",class:{ 'menushik': _vm.menushik },style:({ top: _vm.showTop + 'px' })},[(_vm.routerShow)?_c('div',_vm._l((_vm.filterMenus(false)),function(item,index){return _c('router-link',{key:index,staticClass:"item center",attrs:{"tag":"div","to":{ name: item.name },"event":""},nativeOn:{"click":function($event){return _vm.goToRouter(item.name, 0)}}},[_c('i',{staticClass:"iconfont icon-zhu",class:item.meta.icon}),_vm._v(" "),_c('span',{staticClass:"nav-title"},[_vm._v(_vm._s(item.meta.title))]),_vm._v(" "),(item.name == 'message' && _vm.$store.state.messageCount)?_c('span',{staticClass:"dota-red text count"},[_vm._v(_vm._s(_vm.$store.state.messageCount))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"iconfont icon-iconarrowsright1"})])}),1):_vm._e(),_vm._v(" "),(_vm.routerShow)?_c('div',{staticClass:"shink scroll-bute"},[(_vm.$route.fullPath.indexOf('operate') >= 0)?_c('div',[_vm._m(0),_vm._v(" "),_vm._l((_vm.filterMenus(true)),function(item,index){return _c('router-link',{key:index,staticClass:"item center",attrs:{"tag":"div","to":{ name: item.name, params: { id: 0 } },"event":""},nativeOn:{"click":function($event){return _vm.goToRouter(item.name, 0)}}},[_c('i',{staticClass:"iconfont plugin",class:item.meta.icon}),_vm._v(" "),_c('span',{staticClass:"nav-title"},[_vm._v(_vm._s(item.meta.title))]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-iconarrowsright1"})])})],2):_vm._l((_vm.mgrdeptlist),function(zhu){return _c('div',{key:zhu.index},[_c('div',{staticClass:"item center plugins"},[_c('i',{staticClass:"iconfont icon-huaban icon-zhu"}),_vm._v(" "),_c('span',{staticClass:"nav-title"},[_vm._v("\n                  "+_vm._s(zhu.positionName)+"\n                ")])]),_vm._v(" "),_vm._l((_vm.filterMenus(true)),function(item,index){return (item.name == 'member' || (zhu.workflowlist && zhu.workflowlist.length))?_c('router-link',{key:index,staticClass:"item center",attrs:{"tag":"div","to":{ name: item.name, params: { id: zhu.positionId } },"event":""},nativeOn:{"click":function($event){return _vm.goToRouter(item.name, zhu.positionId)}}},[_c('i',{staticClass:"iconfont plugin",class:item.meta.icon}),_vm._v(" "),_c('span',{staticClass:"nav-title"},[_vm._v(_vm._s(item.meta.title))]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-iconarrowsright1"})]):_vm._e()})],2)})],2):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"main-wrap",style:({ marginTop: _vm.isTop ? '80px' : '' })},[_c('div',{ref:"maincontent",staticClass:"main-content"},[_c('keep-alive',{attrs:{"include":_vm.$store.state.keepArray}},[(_vm.routerShow && _vm.$store.state.currentCompany)?_c('router-view'):_vm._e()],1)],1)])]),_vm._v(" "),_c('footerb'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.storeShow),expression:"storeShow"}],staticClass:"storelist",class:{ 'anishow': _vm.storeShow },style:({ top: _vm.top, left: _vm.left }),on:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"store-item",on:{"click":_vm.changeStore}},[_c('i',{staticClass:"iconfont icon-clear clear"})]),_vm._v(" "),_c('div',{staticClass:"store-scroll scroll-bute"},_vm._l((_vm.componylist),function(item){return _c('div',{key:item.companyid,staticClass:"store-item item-hover",on:{"click":function($event){return _vm.selectStore(item)}}},[_c('img',{staticClass:"store-img",attrs:{"src":_vm.$loadImg(item.logo)}}),_vm._v(" "),_c('span',{staticClass:"store-name-two chaname"},[_c('div',{staticClass:"store-name-two chaname",staticStyle:{"flex-direction":"column","align-items":"flex-start","margin":"0"}},[_c('label',{staticClass:"fullname",staticStyle:{"margin-bottom":"10px"}},[_vm._v(_vm._s(item.shortname))]),_vm._v(" "),(item.positionName)?_c('div',{staticClass:"store-post",style:({ background: item.userright == 1 || item.userright == 2 ? '#D16562' : item.userright == 3 ? '#9861CF' : '#ffffff', color: item.userright == 1 || item.userright == 2 || item.userright == 3 ? '#ffffff' : '#3291F8', border: item.userright != 1 && item.userright != 2 && item.userright != 3 ? '1px solid #3291F8' : '' })},[_vm._v("\n              "+_vm._s(item.positionName))]):_vm._e()]),_vm._v(" "),(item.taskcnt)?_c('span',{staticClass:"dota-red count"}):_vm._e()]),_vm._v(" "),(item.companyid == _vm.$store.state.currentCompany.companyid)?_c('i',{staticClass:"iconfont icon-duihao duihao"}):_vm._e()])}),0)]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.storeShow),expression:"storeShow"}],staticClass:"mask"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item center plugins"},[_c('i',{staticClass:"iconfont icon-chajian icon-zhu"}),_vm._v(" "),_c('span',{staticClass:"nav-title"},[_vm._v("\n                  插件\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_main = (esExports);
// CONCATENATED MODULE: ./src/views/main.vue
function injectStyle (ssrContext) {
  __webpack_require__("YSck")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63f6bc9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  views_main,
  selectortype_template_index_0_src_views_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_main = (Component.exports);

// CONCATENATED MODULE: ./src/router/router.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return operateMenus; });
/* unused harmony export setupMenus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return routers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSetupMenus; });


var loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: '登录'
  },
  component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(__webpack_require__.bind(null, "Quw4")).then(function (module) {
      resolve(module);
    });
  }
};

var page404 = {
  path: '*',
  name: 'error-404',
  meta: {
    title: '页面不存在'
  },
  component: function component() {
    return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "LWjT"));
  }
};

var page500 = {
  path: '/500',
  meta: {
    title: '服务端错误'
  },
  name: 'error-500',
  component: function component() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "0Gql"));
  }
};

var printRouter = {
  path: '/print/:insid',
  name: 'print',
  meta: {
    title: '打印'
  },
  component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(59)]).then(__webpack_require__.bind(null, "vbXH")).then(function (module) {
      resolve(module);
    });
  }
  // 流程详情
};var flowdetail = function flowdetail(resolve) {
  Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, "cV1q")).then(function (module) {
    resolve(module);
  });
};
var taskdetail = function taskdetail(resolve) {
  Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "pzN1")).then(function (module) {
    resolve(module);
  });
};
// 岗位成员,岗位管理 都用
var Member = function Member(resolve) {
  Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(__webpack_require__.bind(null, "Uq7j")).then(function (module) {
    resolve(module);
  });
};
// 档案详情,岗位管理 操作都用
var AchiveDetail = function AchiveDetail(resolve) {
  Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "FrCj")).then(function (module) {
    resolve(module);
  });
};
var Toarchive = function Toarchive(resolve) {
  Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "DLMR")).then(function (module) {
    resolve(module);
  });
};
// 制度 审批 approval
var institutionapproval = function institutionapproval(resolve) {
  Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(62)]).then(__webpack_require__.bind(null, "YLPt")).then(function (module) {
    resolve(module);
  });
};

// 操作菜单
var operateMenus = [{ path: 'message', name: 'message', meta: { title: '消息', icon: 'icon-xiaoxi', isplugin: false }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, "fgdu")).then(function (module) {
      resolve(module);
    });
  } },
// { path: 'pending', name: 'pending', meta: { title: '待处理', icon: 'icon-dai', isplugin: false }, component: (resolve) => { import('views/pending/pending').then((module) => { resolve(module) }) } },
// { path: 'task', name: 'task', meta: { title: '任务', icon: 'icon-task', isplugin: false }, component: (resolve) => { import('views/task/task').then((module) => { resolve(module) }) } },
{ path: 'sixS', name: 'sixS', meta: { title: '6S', icon: 'icon-task', isplugin: false }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "7793")).then(function (module) {
      resolve(module);
    });
  } },
// { path: 'task', name: 'task', meta: { title: '任务', icon: 'icon-task', isplugin: false }, component: (resolve) => { import('views/taskNew/taskMainNew').then((module) => { resolve(module) }) } },
{ path: 'workflow', name: 'workflow', meta: { title: '流程', icon: 'icon-qizi', isplugin: false }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "dvin")).then(function (module) {
      resolve(module);
    });
  } }, { path: 'institution', name: 'institution', props: true, meta: { title: '制度', icon: 'icon-zhidu', isplugin: true }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(60)]).then(__webpack_require__.bind(null, "y5w4")).then(function (module) {
      resolve(module);
    });
  } }, { path: 'institution/dept/select', name: 'institutionselectdept', props: true, meta: { title: '关联岗位' }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "lqId")).then(function (module) {
      resolve(module);
    });
  } }, { path: 'archive', name: 'archive', meta: { title: '档案', icon: 'icon-dangan', isplugin: true }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(68)]).then(__webpack_require__.bind(null, "lkre")).then(function (module) {
      resolve(module);
    });
  } }, { path: 'leave', name: 'leave', meta: { title: '请假', icon: 'icon-qingjia', isplugin: true }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(__webpack_require__.bind(null, "cUbI")).then(function (module) {
      resolve(module);
    });
  } }, { path: 'reimbur', name: 'reimbur', meta: { title: '报销', icon: 'icon-baoxiao', isplugin: true }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "bMrE")).then(function (module) {
      resolve(module);
    });
  } }];
// const depset = { path: 'depset', name: 'depset', meta: { title: '岗位管理', icon: 'icon-deptset', isplugin: false }, component: (resolve) => { import('views/deptset/deptlist').then((module) => { resolve(module) }) } }


var setSixS = { path: 'setSixS', name: 'setSixS', meta: { title: '6S', icon: 'icon-rili', isplugin: false }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(53)]).then(__webpack_require__.bind(null, "O1TF")).then(function (module) {
      resolve(module);
    });
  } };
var post = { path: 'post', name: 'post', meta: { title: '岗位', icon: 'icon-deptset', isplugin: false }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(__webpack_require__.bind(null, "PrQL")).then(function (module) {
      resolve(module);
    });
  } };
var flowset = { path: 'flowset', name: 'flowset', meta: { title: '流程', icon: 'icon-flowset', isplugin: false }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(72)]).then(__webpack_require__.bind(null, "PNXo")).then(function (module) {
      resolve(module);
    });
  } };
var pulginset = { path: 'pulginset', name: 'pulginset', meta: { title: '插件', icon: 'icon-chajian', isplugin: false }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(__webpack_require__.bind(null, "dvyy")).then(function (module) {
      resolve(module);
    });
  } };
var member = { path: 'member/:id', name: 'member', meta: { title: '执行授权', icon: 'icon-member', isplugin: true }, component: Member };
var opauthset = { path: 'opauthset/:id', name: 'opauthset', meta: { title: '操作授权', icon: 'icon-auth', isplugin: true }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(__webpack_require__.bind(null, "gNzK")).then(function (module) {
      resolve(module);
    });
  } };
var authList = { path: 'authset', name: 'authList', meta: { title: '管理授权', icon: 'icon-auth', isplugin: false }, component: function component(resolve) {
    Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(73)]).then(__webpack_require__.bind(null, "HhE4")).then(function (module) {
      resolve(module);
    });
  } };

var setupMenus = [
// depset,
setSixS, post, flowset, pulginset, member, opauthset, authList];
function getSetupMenus(userright) {
  // 按照要求，除了管理授权（authList）只给管理员，其他的直接放开
  var menus = [setSixS, post, flowset, pulginset, opauthset];
  if (userright === 1 || Object(permission["a" /* hasPrivilege */])('/auth/position/editPosition')) {
    menus.push(authList);
  }
  return menus;
  /*
  let _archive = hasPrivilege('/auth/archive/*')
  switch (userright) {
    case 1:// 超级管理员
      return [setSixS, post, flowset, pulginset, opauthset, authList]
    case 2:// 公司操作管理人
      let munus = [setSixS, post, flowset, pulginset]
      return munus
    case 3:// 执行人
      if (_archive) {
        return [pulginset, post]
      }
      return [post]
    case 4:
      if (_archive) {
        return [pulginset]
      }
      return []
    case 5:
      if (_archive) {
        return [pulginset]
      }
      return []
    case 6:
      return [pulginset]
    default:
      break
  }
  return [
    setSixS,
    flowset,
    pulginset,
    opauthset
  ]
  */
}
var appRouter = [{
  path: '/',
  redirect: '/operate/message'
}, {
  path: '/operate',
  name: 'operate',
  meta: {
    title: '操作',
    icon: 'key'
  },
  component: src_views_main,
  children: [].concat(operateMenus, [{ path: 'task/taskTwo', name: 'taskTwo', meta: { title: '岗位任务详情' }, component: function component(resolve) {
      __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "UKl1")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/taskMainNew', name: 'taskMainNew', meta: { title: '任务', icon: 'icon-task', isplugin: false }, component: function component(resolve) {
      __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, "h4s/")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/daptdetail/:id', name: 'daptdetail', meta: { title: '岗位任务详情' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "dByn")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/check/:id', name: 'deptTaskCheck', meta: { title: '任务考核表' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "PRwz")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/daptdetail/:id/:year/:month', name: 'daptdetailhistory', meta: { title: '岗位任务详情' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(__webpack_require__.bind(null, "287b")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/daptlist', name: 'companydaptlist', meta: { title: '任务' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "wd0N")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/taskScoreList', name: 'taskScoreList', meta: { title: '任务' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "GyTU")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/taskHistoryScoreList', name: 'taskHistoryScoreList', meta: { title: '任务' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(__webpack_require__.bind(null, "ncJA")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/add/:id?/:positionId?/:positionName?/:addType?/:dutyId?/:dutyName?', name: 'addtaskNew', meta: { title: '添加任务' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "Sjow")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'pending/add/:id?/:positionId?/:positionName?/:addType?/:dutyId?/:dutyName?', name: 'addtaskNewFromPending', meta: { title: '添加任务' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "Sjow")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/list/:year?/:month?', name: 'tasklist', meta: { title: '任务列表' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(51)]).then(__webpack_require__.bind(null, "1QpT")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/history/:positionId', name: 'taskhistory', meta: { title: '历史评分' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(__webpack_require__.bind(null, "spUs")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'message/info/:noticeId', name: 'messageinfo', meta: { title: '消息详情' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, "cqk/")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'task/detail/:id/:year?/:month?', name: 'taskdetail', meta: { title: '任务详情' }, component: taskdetail }, { path: 'pending/detail/:id', name: 'taskListfromPending', meta: { title: '任务详情' }, component: taskdetail }, { path: 'message/detail/:id', name: 'taskListfromMessage', meta: { title: '任务详情' }, component: taskdetail }, { path: 'archive/add', name: 'archiveadd', meta: { title: '添加档案' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "JCLE")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'archive/list', name: 'archivelist', meta: { title: '档案' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "9j63")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'archive/list_three', name: 'archivelistThree', meta: { title: '档案' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "idEU")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'archive/listDetail/:id', name: 'archivelistDetail', meta: { title: '档案详情' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(__webpack_require__.bind(null, "RBZu")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'archive/archive_search', name: 'archivesearch', meta: { title: '档案搜索' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(74)]).then(__webpack_require__.bind(null, "k2ps")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'archive/add/directory', name: 'archivedirectory', meta: { title: '选择归档目录' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(58)]).then(__webpack_require__.bind(null, "Oye3")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'workflow/listtest', name: 'listtest', meta: { title: '测试' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(66)]).then(__webpack_require__.bind(null, "Ggo1")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'workflow/detail/:id/:type', name: 'wkfldetail', meta: { title: '流程详情' }, component: flowdetail }, { path: 'pending/detail/:id/:type', name: 'wkfldetailfromPending', meta: { title: '流程详情' }, component: flowdetail }, { path: 'message/detail/:id/:type', name: 'wkfldetailfromMessage', meta: { title: '流程详情' }, component: flowdetail }, { path: 'message/message_toBeReviewed', name: 'toBeReviewedMessage', meta: { title: '待审核岗位' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(69)]).then(__webpack_require__.bind(null, "FTZI")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'workflow/institutionapproval', name: 'institutionapproval', meta: { title: '制度审批' }, component: institutionapproval }, { path: 'workflow/add', name: 'addwkfl', meta: { title: '添加流程' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "sYVb")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'workflow/node/:insid/:id', name: 'wkflnode', meta: { title: '流程节点' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(52)]).then(__webpack_require__.bind(null, "wXT9")).then(function (module) {
        resolve(module);
      });
    } }, { path: ':type/detail/:id', name: 'archivedetail', meta: { title: '档案详情' }, component: AchiveDetail }, { path: ':type/toarchive/:id', name: 'toarchive', meta: { title: '归档' }, component: Toarchive }, { path: 'message/detail/:id', name: 'archivedetailfromMessage', meta: { title: '档案详情' }, component: AchiveDetail }, { path: 'institution/add/:scope', name: 'institutionadd', meta: { title: '添加制度' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(__webpack_require__.bind(null, "HlwJ")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'reimbur/add', name: 'reimburadd', meta: { title: '添加明细' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(__webpack_require__.bind(null, "WuSY")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'sixS/sixSAssessment', name: 'sixSAssessment', meta: { title: '年度考核' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "0oXB")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'sixS/sixSAssess', name: 'sixSAssess', meta: { title: '6S考核表' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(55)]).then(__webpack_require__.bind(null, "U36a")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'sixS/sixSUser', name: 'sixSUser', meta: { title: '6S考核表' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(67)]).then(__webpack_require__.bind(null, "d+BC")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'sixS/setRemuneration', name: 'setRemuneration', meta: { title: '设置薪酬基数' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "hlvA")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'sixS/sixSRank', name: 'sixSRank', meta: { title: '生成月排名' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(65)]).then(__webpack_require__.bind(null, "7Tt2")).then(function (module) {
        resolve(module);
      });
    } }])
}, {
  path: '/setup',
  name: 'setup',
  meta: {
    title: '设置',
    icon: 'key'
  },
  component: src_views_main,
  children: [].concat(setupMenus, [{ path: 'depset/add/:positionId?', name: 'adddept', meta: { title: '编辑岗位' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, "+JAT")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'depset/deptdisable/', name: 'deptdisable', meta: { title: '停用岗位' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(__webpack_require__.bind(null, "Hz42")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'depset/flowdetail/:id/:type', name: 'wkfldetailfromDisable', meta: { title: '流程详情' }, component: flowdetail }, { path: 'depset/taskdetail/:id', name: 'taskListfromDisable', meta: { title: '任务详情' }, component: taskdetail }, { path: 'depset/search/:positionId?', name: 'deptsearch', meta: { title: '搜索' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(61)]).then(__webpack_require__.bind(null, "m7R5")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'depset/proportion/:ratio/:itemIndex/:titleType/:positionId', name: 'proportion', meta: { title: '添加职责' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(54)]).then(__webpack_require__.bind(null, "59r0")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'depset/instity', name: 'deptinstity', meta: { title: '制度' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, "0i+O")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'depset/detail/:id', name: 'depsetarchivedetail', meta: { title: '档案详情' }, component: AchiveDetail }, { path: 'depset/member/:id', name: 'detpmember', meta: { title: '执行授权' }, component: Member }, { path: ':type/add', name: 'flowadd', meta: { title: '编辑流程' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "J9zz")).then(function (module) {
        resolve(module);
      });
    } }, { path: ':type/node/add', name: 'nodeadd', meta: { title: '流程节点' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "sBpv")).then(function (module) {
        resolve(module);
      });
    } }, { path: ':type/dept/select', name: 'selectdept', props: true, meta: { title: '选择发起方' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "lqId")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'pulginset/serachme/list', name: 'serachmelist', meta: { title: '报销类别' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(57)]).then(__webpack_require__.bind(null, "nTbz")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'pulginset/directory/list', name: 'directorylist', meta: { title: '目录管理' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(64)]).then(__webpack_require__.bind(null, "6rnd")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'pulginset/directoryFirst/list', name: 'directoryFirst', meta: { title: '目录管理' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(63)]).then(__webpack_require__.bind(null, "kerL")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'pulginset/directorySecond/list', name: 'directorySecond', meta: { title: '目录管理' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(__webpack_require__.bind(null, "NKA6")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'pulginset/setDayLog', name: 'setDayLog', meta: { title: '日志工作设置' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "zPYT")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'pulginset/flows', name: 'pulgflows', meta: { title: '报销模版' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "TUhQ")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'opauthset/:id/opauthdetail/:number/:type', name: 'opauthdetail', meta: { title: '报销' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(70)]).then(__webpack_require__.bind(null, "A0Oo")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'opauthset/:id/opauthdetail/addopauth/:number/:type/:templatepartid', name: 'addopauth', meta: { title: '添加授权人' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "a8XM")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'setSixS/dimensionalitySixS', name: 'dimensionalitySixS', meta: { title: '6S维度' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(__webpack_require__.bind(null, "7Hzy")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'setSixS/checkRatioSixS', name: 'checkRatioSixS', meta: { title: '6S考核比例' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "T1sn")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'post/postAdd', name: 'postAdd', meta: { title: '添加岗位' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(56)]).then(__webpack_require__.bind(null, "H9QX")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'post/executor', name: 'executor', meta: { title: '添加/编辑执行人' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(71)]).then(__webpack_require__.bind(null, "Fw32")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'post/toBeReviewed', name: 'toBeReviewed', meta: { title: '待审核岗位' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(__webpack_require__.bind(null, "GFf1")).then(function (module) {
        resolve(module);
      });
    } }, { path: 'authset/add', name: 'authAdd', meta: { title: '添加授权人' }, component: function component(resolve) {
      Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "Cvja")).then(function (module) {
        resolve(module);
      });
    } }])
}];

var routers = [loginRouter, page404, page500, printRouter].concat(appRouter);


/***/ }),

/***/ "JWnO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkRCMTA0MkZGQzVCQTExRTc5MjkxREZCMUNDNkFFMkM5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkRCMTA0MzAwQzVCQTExRTc5MjkxREZCMUNDNkFFMkM5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6REIxMDQyRkRDNUJBMTFFNzkyOTFERkIxQ0M2QUUyQzkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6REIxMDQyRkVDNUJBMTFFNzkyOTFERkIxQ0M2QUUyQzkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6tFFFQAAAAh0lEQVR42mL8P4eBjYGBoRuIY4CYEYgXA3EpEP9igACy5FmARBcQ5zEgAIj9HYgroHyy5BmBLn4LZAgxoIJ3QCwMZZMlDzL4PwN2wAilyZJnYqARGDV41OBRg0cNHjV48Bj8Dov4OxxsouWZoLUqOpiDxCZLHlRLl0Hrr1gkhbVIisiSBwgwANOGLSmik3g3AAAAAElFTkSuQmCC"

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// EXTERNAL MODULE: ./src/api/user.js
var user = __webpack_require__("vMJZ");

// EXTERNAL MODULE: ./src/api/baseapi.js
var baseapi = __webpack_require__("r1Jv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//




/* harmony default export */ var App = ({
  name: 'App',
  created: function created() {
    var version = Object(user["b" /* getStorage */])('version');
    if (!version) {
      Object(baseapi["a" /* getVersion */])().then(function (res) {
        if (res.code === api_config["c" /* resCode */].ERR_OK) {
          Object(user["e" /* setStorage */])('version', res.resdata);
          // setStorage('version', "v3.0.6")
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1944b49e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("a9R0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./src/store/index.js + 1 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./src/router/router.js + 3 modules
var router = __webpack_require__("JU1R");

// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);

var routerConfig = {
  mode: 'history',
  base: '/pm/',
  routes: router["c" /* routers */]
};
var router_router = new vue_router_esm["a" /* default */](routerConfig);
router_router.beforeEach(function (to, form, next) {
  if (location.host.indexOf('pm.xb969.com') >= 0) {
    var ishttps = document.location.protocol == 'https:';
    if (!ishttps) {
      var httpUrl = document.location + '';
      var str = httpUrl.split('http://');
      window.location.href = 'https://' + str[1];
    }
  }

  document.title = to.meta.title || '加西亚';
  if (store["a" /* default */].state.user) {
    next();
  } else {
    if (to.path == '/login') {
      next();
    } else {
      next({ name: 'login' });
    }
  }
});

router_router.afterEach(function (to, from) {
  window.scrollTo(0, 50);
});
/* harmony default export */ var src_router = (router_router);
// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.esm.js
var vue_lazyload_esm = __webpack_require__("AXdl");

// EXTERNAL MODULE: ./node_modules/iview/dist/iview.js
var iview = __webpack_require__("BTaQ");
var iview_default = /*#__PURE__*/__webpack_require__.n(iview);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/common/js/reqdata.js
var reqdata = __webpack_require__("HNGl");

// EXTERNAL MODULE: ./src/common/js/tip.js
var tip = __webpack_require__("IMJW");

// CONCATENATED MODULE: ./src/common/js/axiosset.js













/* axios 配置 */
var tokenFull = Object(user["b" /* getStorage */])('token');
axios_default.a.defaults.baseURL = api_config["a" /* apiDomain */];
axios_default.a.defaults.data = Object(reqdata["f" /* getCommonData */])();
axios_default.a.defaults.timeout = 15000;

if (tokenFull) {
  axios_default.a.defaults.headers.common['xibenesb-accesstoken'] = tokenFull.access_token;
}

function refshToken() {
  return new promise_default.a(function (resolve, reject) {
    Object(baseapi["b" /* refershToken */])().then(function (res) {
      if (res.code === api_config["c" /* resCode */].ERR_OK) {
        tokenFull = res.resdata;
        Object(user["e" /* setStorage */])('token', res.resdata);
        resolve(res.resdata);
      }
    });
  });
}
var getToakenAsync = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(config) {
    var result;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return refshToken();

          case 2:
            result = _context.sent;

            config.headers.common['xibenesb-accesstoken'] = result.access_token;
            return _context.abrupt('return', config);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getToakenAsync(_x) {
    return _ref.apply(this, arguments);
  };
}();

function crateToast(title, desc) {
  Object(tip["b" /* notice */])(title, '');
}
// 添加响应拦截器
axios_default.a.interceptors.response.use(function (response) {
  if (response.data.code === api_config["c" /* resCode */].ERR_EX) {
    refshToken().then(function (res) {
      window.location.reload();
    });
  } else if (response.data.code === api_config["c" /* resCode */].ERR_OR || response.data.code === api_config["c" /* resCode */].ERR_RF || response.data.code === api_config["c" /* resCode */].ERR_TIMEOUT) {
    Object(user["d" /* loginOut */])();
    // let _errMsg = response.data.code === resCode.ERR_TIMEOUT ? '' : '你已被挤下线'
    if (response.data.code != api_config["c" /* resCode */].ERR_TIMEOUT) {
      // refreshToken 过期不提醒，其他提醒
      crateToast('你已被挤下线', '');
    }
    // crateToast(_errMsg, '')
    src_router.replace({ name: 'login' });
  } else if (response.data.code === api_config["c" /* resCode */].ERR_XS) {
    if (response.data.msg.indexOf('档案的查看权限') == -1) {
      crateToast(response.data.msg, '');
    }
    if (response.data.msg.indexOf('网络异常') > -1 && src_router.history.current.name != 'error-500') {
      // router.push({ name: 'error-500', params: { isgoback: true } })
      // crateToast(response.data.msg, '')
    }
  }
  return response;
}, function (error) {
  crateToast('网络错误', '请检查网络或稍候重试');
  // if (router.history.current.name != 'error-500') {
  // router.push({ name: 'error-500', params: { isgoback: true } })
  // crateToast(response.data.msg, '')
  // }
  // return Promise.reject(error)
  return error;
});

// 添加请求拦截器
axios_default.a.interceptors.request.use(function (config) {
  if (!config.url.match(/public/) && tokenFull) {
    var nowDate = new Date();
    var endDate = moment_default()(tokenFull.access_token_createtimestamp).add(tokenFull.access_token_expirein, 's');
    var isRefresh = endDate.isBefore(nowDate);
    if (isRefresh) {
      return getToakenAsync(config);
    } else {
      return config;
    }
  } else {
    return config;
  }
  // return config
}, function (error) {
  return promise_default.a.reject(error);
});

vue_esm["default"].use(vue_axios_min_default.a, axios_default.a);
/* axios 配置end */
// EXTERNAL MODULE: ./node_modules/iview/dist/styles/iview.css
var styles_iview = __webpack_require__("+skl");
var styles_iview_default = /*#__PURE__*/__webpack_require__.n(styles_iview);

// EXTERNAL MODULE: ./src/common/stylus/index.styl
var stylus = __webpack_require__("34KM");
var stylus_default = /*#__PURE__*/__webpack_require__.n(stylus);

// EXTERNAL MODULE: ./src/common/fonts/iconfont.css
var iconfont = __webpack_require__("1g2b");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// EXTERNAL MODULE: ./src/common/fonts/iconfont1.css
var iconfont1 = __webpack_require__("XamU");
var iconfont1_default = /*#__PURE__*/__webpack_require__.n(iconfont1);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./src/base/confirm/confirm.vue + 2 modules
var confirm_confirm = __webpack_require__("XEAW");

// CONCATENATED MODULE: ./src/base/confirm/index.js




var defaults = {
  showFlag: false,
  btnCan: '否',
  btnOk: '是',
  conDesc: '\u5185\u5BB9',
  cancelA: function cancelA() {
    this.close();
  },
  confirmA: function confirmA() {
    this.close();
  }
};

var confirmVueLoading = void 0;
var confirmVueConstructor = vue_esm["default"].extend(confirm_confirm["a" /* default */]);
// 这里关闭的时候返回promise
confirmVueConstructor.prototype.close = function () {
  var vm = this;
  confirmVueLoading = null;
  var promise = new promise_default.a(function (resolve, reject) {
    if (vm.$el && vm.$el.parentNode) {
      vm.$el.parentNode.removeChild(vm.$el);
    }
    resolve();
    vm.$destroy();
    vm.showFlag = false;
  });
  return promise;
};
var confirm_confirmBox = function confirmBox() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (vue_esm["default"].prototype.$isServer) return;
  console.log(options);
  options = assign_default()({}, defaults, options);

  var parent = document.body;
  console.log('confirmVueLoading', confirmVueLoading);
  // 没有关闭不允许新开
  if (confirmVueLoading) {
    return confirmVueLoading;
  }
  // eslint-disable-next-line new-cap
  var instance = new confirmVueConstructor({
    el: document.createElement('div'),
    data: options
  });
  console.log('instance', instance);
  parent.appendChild(instance.$el);
  vue_esm["default"].nextTick(function () {
    instance.showFlag = true;
  });
  confirmVueLoading = instance;
  return instance;
};

/* harmony default export */ var base_confirm = (confirm_confirmBox);
// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/echarts/index.js + 548 modules
var echarts = __webpack_require__("XLwt");

// CONCATENATED MODULE: ./src/main.js















// import breadcrumbs from 'base/breadcrumb/breadcrumbs'

vue_esm["default"].prototype.$echarts = echarts;

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].use(iview_default.a);
vue_esm["default"].use(vue_lazyload_esm["a" /* default */], {
  preLoad: 2, // 预加载的屏幕宽高比
  observer: true, // 当指定元素进入页面时，自动触发函数 azyload 默认的触发方式是当页面滚动时，遍历全部元素，查看元素是否在视图内，从而加载图片。因此，当元素特别多时，非常消耗性能。采用 observer 则能避免这个问题，很好地提高性能。-- 兼容性一般， IE兼容11
  loading: __webpack_require__("HfaK"),
  error: __webpack_require__("HfaK"),
  attempt: 10
});
/* eslint-disable */
String.prototype.xbTrim = function () {
  return this.replace(/^\s+|\s+$/g, '');
};
/* 全局方法 未初始化调用时才会初始化 */
vue_esm["default"].prototype.$confirm = base_confirm;

vue_esm["default"].prototype.$loadImg = function (value) {
  if (value == "" || value == undefined || value == null) {
    return __webpack_require__("HfaK");
  }
  return value;
};

vue_esm["default"].prototype.$remarkFormater = function (value) {
  var str = value.replace(/\n/g, '<br>');
  var strRegex = '((https|http|ftp)://)?' + // (https或http或ftp):// 可有可无
  // eslint-disable-next-line no-tabs
  '(([\\w_!~*\'()\\.&=+$%-]+: )?[\\w_!~*\'()\\.&=+$%-]+@)?' + // ftp的user@  可有可无
  // eslint-disable-next-line no-tabs
  '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
  // eslint-disable-next-line no-tabs
  '|' + // 允许IP和DOMAIN（域名）
  '(localhost)|' +
  // eslint-disable-next-line no-tabs
  '([\\w_!~*\'()-]+\\.)*' + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
  // eslint-disable-next-line no-tabs
  '\\w+\\.' + // 一级域名 -英文或数字  加上.
  // eslint-disable-next-line no-tabs
  '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
  // eslint-disable-next-line no-tabs
  '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
  // eslint-disable-next-line no-tabs
  // '((/?)|' + // url无参数结尾 - 斜杆或这没有
  // eslint-disable-next-line no-tabs
  '((/[\\w_!~ *\'()\\.;?:@&=+$,%#-]+)+/?)?'; // 请求参数结尾- 英文或数字和[]内的各种字符
  var reg = new RegExp(strRegex, 'g'); // i不区分大小写 g 全局搜索
  return str.replace(reg, function (str1, str2) {
    // console.log(str1, str2)
    var link = str2 == '' || str2 == null ? 'http://' + str1 : str1;
    return '<a href="' + link + '" style="color: blue;text-decoration: underline;" target="_blank">' + str1 + '</a>';
  });
};
vue_esm["default"].prototype.$scoreColor = function (value) {
  if (value < 0) {
    // return 'violation-score-red'
    return 'violation-score';
  }
  if (value > 0) {
    // return 'violation-score'
    return 'violation-score-red';
  }
  return '';
};
/// 数字是正数 大于 0 显示 + 
vue_esm["default"].filter('numberPositive', function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';

  value = parseFloat(value);
  if (value > 0) {
    return '+' + value;
  } else {
    return value;
  }
});
/* 全局组件 初始化完成 */
// Vue.component('breadcrumbs', breadcrumbs)

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: src_router,
  store: store["a" /* default */],
  components: { App: src_App },
  template: '<App/>'
});

/***/ }),

/***/ "O18x":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "T452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pageSize; });
/* unused harmony export upSwitch */
/* unused harmony export rootFile */
var apiUrl = 'http://106.15.187.217:8080/pmrest'; // 接口域名
// let apiUrl = 'http://192.168.16.243:9090/pmrest' // 接口域名
if (location.host.indexOf('localhost') >= 0) {
  apiUrl = '/pmrest';
  // apiUrl = 'http://192.168.16.243:9090/pmrest'
} else if (location.host.indexOf('pm.xb969.com') >= 0) {
  // 部署在 https://pm.xb969.com/pm/login 时，接口请求地址为 https://pm.xb969.com/pmrest
  apiUrl = 'https://pm.xb969.com/pmrest';
} else if (location.host.indexOf('106.15.187.217:8085') >= 0) {
  // 部署在 http://106.15.187.217:8085/pm/login 时，接口请求地址为 http://106.15.187.217:8080/pmrest
  apiUrl = 'http://106.15.187.217:8080/pmrest';
} else if (location.host.indexOf('garcia.xb969.com') >= 0) {
  apiUrl = 'https://garcia.xb969.com/pmrest';
}

// 接口域名s
var apiDomain = apiUrl;
// 接口返回状态码
var resCode = {
  ERR_OK: 1000,
  ERR_EX: 1005,
  ERR_OR: 1006,
  ERR_XS: 2000,
  ERR_RF: 1004,
  ERR_NR: 1007,
  ERR_NL: 1008,
  ERR_DS: 1009,
  ERR_TIMEOUT: 1015, // refreshToken 过期
  ERR_DE: 51101 // 停用岗位-当前有任务-需要用户二次确认
};
var rootFile = '';
/* 返回值 */
function upSwitch(res) {
  switch (res.data.code) {
    case resCode.ERR_OK:
      return res.data;
  }
}

// 显示条数
var pageSize = 10;


/***/ }),

/***/ "XEAW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/base/confirm/confirm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var confirm_confirm = ({
  props: {
    text: {
      type: String,
      default: '小西提醒'
    },
    desc: {
      type: String,
      default: '是否退出当前账号'
    },
    confirmBtnText: {
      type: String,
      default: '是'
    },
    cancelBtnText: {
      type: String,
      default: '否'
    },
    conDescOne: {
      type: String,
      default: '确认忘记密码？'
    },
    isShow: {
      type: Boolean,
      default: false
    },
    showOne: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showFlag: false,
      btnCan: this.cancelBtnText,
      btnOk: this.confirmBtnText,
      conDesc: this.desc,
      cancelA: null,
      confirmA: null,
      isShows: this.isShow,
      showOneS: this.showOne
    };
  },

  methods: {
    show: function show() {
      this.showFlag = true;
    },
    hide: function hide() {
      this.showFlag = false;
    },
    cancel: function cancel() {
      this.hide();
      this.$emit('cancel');
    },
    closeHide: function closeHide() {
      this.hide();
      this.$emit('close');
    },
    confirm: function confirm() {
      this.hide();
      this.$emit('confirm');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04aeed04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/confirm/confirm.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"confirm-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFlag),expression:"showFlag"}],staticClass:"confirm",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"confirm-wrapper"},[_c('div',{staticClass:"confirm-content"},[_c('div',{staticClass:"header-text"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.cancelA)?_c('i',{staticClass:"iconfont icon-clear close",on:{"click":function($event){$event.stopPropagation();return _vm.cancelA.apply(null, arguments)}}}):_c('i',{staticClass:"iconfont icon-clear close",on:{"click":_vm.closeHide}})]),_vm._v(" "),(_vm.isShows)?_c('div',{staticClass:"content item-break-all-word",staticStyle:{"font-weight":"700"}},[_vm._v("\n          "+_vm._s(_vm.conDescOne)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.btnCan == null)?_c('div',{staticClass:"content item-break-all-word"},[_c('div',[_vm._v("该岗位有未生成周考核")]),_vm._v(" "),_c('div',[_vm._v("无法删除岗位")])]):(_vm.cancelA)?_c('div',{staticClass:"content item-break-all-word",domProps:{"innerHTML":_vm._s(_vm.conDesc)}}):_c('div',{staticClass:"content item-break-all-word"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.conDesc))]})],2),_vm._v(" "),(_vm.cancelA)?_c('div',{staticClass:"operate"},[(_vm.btnCan != null)?_c('span',{staticClass:"left",on:{"click":function($event){$event.stopPropagation();return _vm.cancelA.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.btnCan))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"right",on:{"click":function($event){$event.stopPropagation();return _vm.confirmA.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.btnOk))])]):_c('div',{staticClass:"operate"},[(_vm.btnCan)?_c('span',{staticClass:"left",on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.btnCan))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"right",on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.btnOk))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var base_confirm_confirm = (esExports);
// CONCATENATED MODULE: ./src/base/confirm/confirm.vue
function injectStyle (ssrContext) {
  __webpack_require__("Alzq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04aeed04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  confirm_confirm,
  base_confirm_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_base_confirm_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XaOL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "XamU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YSck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZiYx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBDMkQ0RERGQzVCQjExRTc5MUI0Q0RCOTVDQzlDQTgyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBDMkQ0REUwQzVCQjExRTc5MUI0Q0RCOTVDQzlDQTgyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEMyRDRERERDNUJCMTFFNzkxQjRDREI5NUNDOUNBODIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEMyRDREREVDNUJCMTFFNzkxQjRDREI5NUNDOUNBODIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7+Hy1RAAAAkElEQVR42mL8P4eBjYGBoRuIY4CYEYgXA3EpEP+6bHYJSOGWZ4AArPIsQKILiPMYEADE/g7EFVA+WfKMQBe/BTKEGFDBOyAWhroYpzyUjVWeCYsgA5oYWfJMDDQCowaPGjxq8KjBowYPHoPfYRF/h4NNtDwTtFZFB3OQ2GTJg2rpMmi1HYuksBZJEVnyAAEGAO6hLLKdFI42AAAAAElFTkSuQmCC"

/***/ }),

/***/ "a9R0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "doFb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hUrq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/api/user.js
var user = __webpack_require__("vMJZ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/base/header/header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var header = ({
  components: {},
  props: {
    islogin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirmShow: function confirmShow() {
      var _this = this;
      var confirm = this.$confirm({
        conDesc: '你是否确定退出登录？',
        cancelA: function cancelA() {
          confirm.close();
        },
        confirmA: function confirmA() {
          Object(user["d" /* loginOut */])();
          confirm.close();
          _this.$router.replace({ name: 'login' });
        }
      });
    },
    showPop: function showPop() {
      this.$emit('showPop', false);
    },
    clickToPMIAction: function clickToPMIAction() {
      window.open('https://pmi.xb969.com/shop/login', '_blank');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79daed9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/header/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header space-between"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"header-out"},[_c('span',{staticClass:"app-name",staticStyle:{"text-decoration":"underline","margin-right":"15px"},on:{"click":_vm.clickToPMIAction}},[_vm._v("新干线观察电脑端\n        >\n      ")]),_vm._v(" "),_c('img',{staticClass:"header-img",attrs:{"src":_vm.$loadImg(_vm.$store.state.user.logourl)}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',[_vm._v(_vm._s(_vm.$store.state.user.dispname))]),_vm._v(" "),_c('span',{staticClass:"userid"},[_vm._v("ID "+_vm._s(_vm.$store.state.user.userid))])]),_vm._v(" "),_c('span',{staticClass:"login-out",on:{"click":_vm.confirmShow}},[_vm._v("[退出]")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrap"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("01ue")}}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v("加西亚")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var header_header = (esExports);
// CONCATENATED MODULE: ./src/base/header/header.vue
function injectStyle (ssrContext) {
  __webpack_require__("doFb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79daed9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  header,
  header_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var base_header_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i3O8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "lGbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/base/footer/footer.vue
//
//
//
//
//
//
//

/* harmony default export */ var footer = ({
  props: {
    islogin: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b929566","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/footer/footer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer center",class:{'opacity':_vm.islogin},staticStyle:{"justify-content":"center"}},[_c('p',[_vm._v("Copyright © 2018  西本新干线     沪ICP12025672号-2    沪公网安备 31010902001335号    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var footer_footer = (esExports);
// CONCATENATED MODULE: ./src/base/footer/footer.vue
function injectStyle (ssrContext) {
  __webpack_require__("BtlD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b929566"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  footer,
  footer_footer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var base_footer_footer = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKN5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "r1Jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return refershToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_reqdata__ = __webpack_require__("HNGl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__("vMJZ");





function getVersion() {
  var url = 'public/login/getversion';
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(url, {
    version: 'V20180329'
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

function refershToken() {
  var url = 'public/login/refreshtoken';
  var token = Object(__WEBPACK_IMPORTED_MODULE_3__user__["b" /* getStorage */])('token');
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(url, {
    reqdata: {
      client_id: __WEBPACK_IMPORTED_MODULE_2_common_js_reqdata__["c" /* clientId */],
      client_secret: __WEBPACK_IMPORTED_MODULE_2_common_js_reqdata__["d" /* clientSecret */],
      grant_type: 'refresh_token',
      refresh_token: token.refresh_token
    }
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}



/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vMJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQrCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStorage; });
/* unused harmony export removeStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loginOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_good_storage__ = __webpack_require__("bFR2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






function setStorage(key, value) {
  __WEBPACK_IMPORTED_MODULE_2_good_storage__["a" /* default */].set(key, value);
  if (key === 'token') {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['xibenesb-accesstoken'] = value.access_token;
  }
}

function getStorage(key) {
  return __WEBPACK_IMPORTED_MODULE_2_good_storage__["a" /* default */].get(key) || '';
}

function removeStorage(key) {
  __WEBPACK_IMPORTED_MODULE_2_good_storage__["a" /* default */].remove(key);
}
// 获取用户信息
function getUserInfo(userid, phone) {
  var url = 'security/masterdata/getuserinfo';
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(url, {
    reqdata: {
      userid: userid,
      phone: phone
    }
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

function getQrCode(biztype, bizid) {
  var url = 'unauth/qrcode/create';
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(url, {
    reqdata: {
      biztype: biztype,
      bizid: bizid
    }
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

function loginOut() {
  // removeStorage('token')
  // removeStorage('user')
  // removeStorage('currentCompany')
  __WEBPACK_IMPORTED_MODULE_2_good_storage__["a" /* default */].clear();
  __WEBPACK_IMPORTED_MODULE_2_good_storage__["a" /* default */].session.clear();
  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('loginOutSet');
  }, 20);
}



/***/ }),

/***/ "vmcJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVFODVCQjJGQzVCQTExRTc5RUIyRDlGQzYxNkZBOUMyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVFODVCQjMwQzVCQTExRTc5RUIyRDlGQzYxNkZBOUMyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUU4NUJCMkRDNUJBMTFFNzlFQjJEOUZDNjE2RkE5QzIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUU4NUJCMkVDNUJBMTFFNzlFQjJEOUZDNjE2RkE5QzIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6pxJPyAAAAjklEQVR42mL8P4eBjYGBoRuIY4CYEYgXA3EpEP9igACs8pfNLuGVZwESXUCcx4AAIPZ3IK6A8smSZwS6+C2QIcSACt4BsTCUjVUe6GK88kxYBBnQxMiSZ2KgERg1eNTgUYNHDR41ePAY/A6L+DscbKLlmaC1KjqYg8QmSx5US5dBq+1YJIW1SIrIkgcIMACGuSyyOBIxLAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "xgJh":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "zBRd":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.36e15ce1bf1842bc4f93.js